import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Benefits from "./pages/Benefits";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import FutureUpdates from "./pages/FutureUpdates";
import StyleGuidePage from "./pages/StyleGuidePage";
import AlertsPage from "./pages/AlertsPage";
import SmartFarmingDashboard from "./pages/SmartFarmingDashboard";
import HistoryPage from "./pages/HistoryPage";
import SettingsPage from "./pages/SettingsPage";
import NotificationPage from "./pages/NotificationPage";
import ProfilePage from "./pages/ProfilePage";
import DevicesPage from "./pages/DevicesPage";
import ContactPage from "./pages/Contact";
import LoginPage from "./pages/Login";
import SignupPage from "./pages/Signup";
import ErrorPage from "./pages/ErrorPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminDevicesPage from "./pages/AdminDevicesPage";
import AdminFaqsPage from "./pages/AdminFaqsPage";
import AdminStoriesPage from "./pages/AdminStoriesPage";
import AdminHomeModulesPage from "./pages/AdminHomeModulesPage";
import AdminPricingPlansPage from "./pages/AdminPricingPlansPage";
import AdminFutureAdminPage from "./pages/AdminFutureAdminPage";
import AdminContactAdminPage from "./pages/AdminContactAdminPage";
import AdminAlertsRulesPage from "./pages/AdminAlertsRulesPage";
import AdminContactResponsesPage from "./pages/AdminContactResponsesPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import SuperAdminAuditPage from "./pages/SuperAdminAuditPage";
import SuperAdminServerLogsPage from "./pages/SuperAdminServerLogsPage";
import SuperAdminContactResponsesPage from "./pages/SuperAdminContactResponsesPage";
import SuperAdminDevicePoolPage from "./pages/SuperAdminDevicePoolPage";
import SuperAdminFirmwarePage from "./pages/SuperAdminFirmwarePage";
import Layout from "./components/Layout";
import ScrollToAnchor from "./ScrollToAnchor"; // ✅ Import scroll handler

function App() {
  return (
    <Router>
      {/* 🔄 Enable smooth scrolling to anchor links */}
      <ScrollToAnchor />

      {/* 📦 Common layout and routes */}
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/style-guide" element={<StyleGuidePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          {/* 🔐 Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <SmartFarmingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notification"
            element={
              <ProtectedRoute>
                <NotificationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <NotificationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices"
            element={
              <ProtectedRoute>
                <DevicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <AlertsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/future-updates"
            element={
              <ProtectedRoute>
                <FutureUpdates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <AdminUsersPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/devices"
            element={
              <AdminRoute>
                <AdminDevicesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/faqs"
            element={
              <AdminRoute>
                <AdminFaqsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/stories"
            element={
              <AdminRoute>
                <AdminStoriesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/home-modules"
            element={
              <AdminRoute>
                <AdminHomeModulesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/pricing-plans"
            element={
              <AdminRoute>
                <AdminPricingPlansPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/future"
            element={
              <AdminRoute>
                <AdminFutureAdminPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/rules"
            element={
              <AdminRoute>
                <AdminAlertsRulesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/contact"
            element={
              <AdminRoute>
                <AdminContactAdminPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/contact-responses"
            element={
              <AdminRoute>
                <AdminContactResponsesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/notifications"
            element={
              <AdminRoute>
                <AdminNotificationsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/super-admin"
            element={
              <SuperAdminRoute>
                <SuperAdminDashboard />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/super-admin/audit"
            element={
              <SuperAdminRoute>
                <SuperAdminAuditPage />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/super-admin/server-logs"
            element={
              <SuperAdminRoute>
                <SuperAdminServerLogsPage />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/super-admin/contact-responses"
            element={
              <SuperAdminRoute>
                <SuperAdminContactResponsesPage />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/super-admin/device-pool"
            element={
              <SuperAdminRoute>
                <SuperAdminDevicePoolPage />
              </SuperAdminRoute>
            }
          />
          <Route
            path="/super-admin/firmware"
            element={
              <SuperAdminRoute>
                <SuperAdminFirmwarePage />
              </SuperAdminRoute>
            }
          />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
